if (!customElements.get('product-media')) {
  class ProductMedia extends HTMLElement {
    selectors = {
      swiper: '.swiper',
      scrollbar: '.swiper-scrollbar',
    };

    settings = {
      slidesPerView: 1,
      spaceBetween: 16,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.354,
        },
      },
    };

    slider = undefined;
    breakpoint = window.matchMedia('(max-width: 989px)');

    constructor() {
      super();
    }

    connectedCallback() {
      this.init();

      // Re-init on viewport changes
      this.breakpoint.addEventListener('change', (event) => {
        this.handleBreakpoint(event);
      });
    }

    init() {
      const swiper = this.querySelector(this.selectors.swiper);
      if (!swiper) return;

      if (this.slider) this.destroy();

      this.slider = new Swiper(swiper, this.settings);

      // Update videos when slide changes
      this.slider.on('slideChange', () => {
        this.updateActiveMedia();
      });

      // Initial update
      this.updateActiveMedia();
    }

    destroy() {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = undefined;
      }
    }

    handleBreakpoint(event) {
      this.init();
    }

    /**
     * Show only the active video in the Swiper
     */
    updateActiveMedia() {
      const swiper = this.querySelector(this.selectors.swiper);
      if (!swiper) return;

      const videos = swiper.querySelectorAll('.swiper-slide video');

      videos.forEach((video) => {
        video.pause();
        video.style.opacity = '0';
        video.style.visibility = 'hidden';
        video.style.zIndex = '';
      });

      const activeVideo = swiper.querySelector('.swiper-slide-active video');
      if (activeVideo) {
        activeVideo.setAttribute('playsinline', '');
        activeVideo.muted = true; // prevents autoplay issues on desktop
        activeVideo.style.opacity = '1';
        activeVideo.style.visibility = 'visible';
        activeVideo.style.zIndex = '10';
      }
    }
  }

  customElements.define('product-media', ProductMedia);
}